import React, { useCallback, useRef } from 'react';
import ModalWrapper from 'src/components/common/modal/ModalWrapper';
import { blueButtonClass } from 'src/components/common/common';
import { UsageTable_MST3040_R01 } from './UsageTable_MST3040_R01';
import { useMST3040_R01Store } from './Store_MST3040_R01';
import { AgGridReact } from 'ag-grid-react';
import { MST3040_R01HeaderDto, MST3040_R01UsageDto } from './Dto_MST3040_R01';
import { useMouseContent } from 'src/utils/mouse/mouseContent';
import { showWarning } from 'src/utils/toast/toastUtil';
import { InputForm } from 'src/components/common/form/input/InputForm';

interface Props {
    usageGridRef: React.RefObject<AgGridReact<MST3040_R01UsageDto> | null>;
	defaultMST3040_R01UsageRow: MST3040_R01UsageDto;
    handleDeleteClick: () => void;
}

export const Modal_MST3040_R01 = ({
    usageGridRef,
    defaultMST3040_R01UsageRow,
}: Props) => {
    const { 
		modalVisible, setModalVisible,
		MST3040_R01UsageList,
		insertMST3040_R01UsageList, 
		removeMST3040_R01UsageList,
	 } = useMST3040_R01Store();

    const modalRef = useRef<HTMLDivElement>(null);
    const modalInfoRef = useRef<HTMLDivElement>(null);
    const isResizing_modal = useRef(false);

    const RESIZER_MODAL = {
        code: 'MST3040_R01_modal',
        type: 'width',
        storageKey: 'MST3040_R01-modal-split-width',
        min: 5,
        max: 80,
        default: 50
    } as const;

    const {
        splitValue: splitValue_modal,
        handleMouseDown: handleMouseDown_modal,
    } = useMouseContent({
        resizer: RESIZER_MODAL,
        isResizing: isResizing_modal,
        containerRef: modalRef,
        infoRef: modalRef
    });

    if (!modalVisible) return null;

    return (
        <ModalWrapper
            size={'qhmd'}
            width={1100}
            overlay={true}
            onOverlayClick={() => setModalVisible(!modalVisible)}
            onEscKeyDown={() => {
                setModalVisible(!modalVisible);
            }}
        >
            <div className="w-full h-[10%] flex items-center px-[24px] bg-gray-100">
                <p className="font-bold">
                    BOM 소요량 대조
                </p>
            </div>
            <div className="w-full h-[75%] flex px-[24px] pt-[2px] pb-[12px] gap-[8px]" ref={modalRef}>
                <div className="h-full" style={{ width: `100%` }} ref={modalInfoRef}>
                    <UsageTable_MST3040_R01 gridRef={usageGridRef} defaultMST3040_R01UsageRow={defaultMST3040_R01UsageRow} />
                </div>
            </div>
            <div className="w-full h-[10%] flex items-center px-[24px] gap-[8px]">
                <button
                    className={`${blueButtonClass} flex-shrink-0 text-white font-semibold px-4  rounded shadow h-[30px]`}
                    onClick={() => setModalVisible(!modalVisible)}
                    disabled={false}
                >
                    확인
                </button>
            </div>
        </ModalWrapper>
    );
};

